import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { v4 as uuid } from 'uuid'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import CubesIcon from '../../../assets/v2/JSX/CubesIcon'
import LeftThreeDot from '../../../assets/v2/JSX/LeftThreeDot'
import RightLineArrowIcon from '../../../assets/v2/JSX/RightLineArrowIcon'
import RightThreeDot from '../../../assets/v2/JSX/RightThreeDot'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import CompanySelect from '../../../components/v2/CompanySelect'
import CountBar from '../../../components/v2/CountBar'
import CustomLink from '../../../components/v2/CustomLink'
import Dropdown from '../../../components/v2/Dropdown'
import GetBetterOffer from '../../../components/v2/GetBetterOffer'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import BaseModal from '../../../components/v2/modals/BaseModal'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { AbroadOffer, currencySymbol, georgianFormatter } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import {
  TravelAbroadState,
  clearAddon,
  clearGroupAddon,
  removeAddon,
  removeGroupAddon,
  setAddon,
  setBetterOffer,
  setCompanyOffers,
  setCurrency,
  setFranchise,
  setGroupAddon,
  setLimit,
  setOffer,
  setOfferTotalPrice,
  setUniquedId,
  updateAddon,
  updateGroupAddon,
} from '../../../store/travelAbroadSlice'
//
//
const TravelOffer = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const [openAddonAccordion, setOpenAddonAccordion] = useState<boolean>(true)
  //
  //
  const [abroadBestOffer, { isLoading: isBestOFferLoading, data: offers }] = api.useNewAbroadBestOfferMutation()
  //
  const [selectedCoverageId, setSelectedCoverageId] = useState<number | undefined>(0)
  //
  // travel currencies
  const { data: travelCurrencies, isLoading: isTravelCurrenciesLoading } = api.useGetTravelCurrenciesQuery('usd-eur')
  //
  //
  // get travel limits by currency
  const { data: travelLimitsByCurrency } = api.useGetTravelLimitsByCurrencyQuery(filter.currency as string, {
    skip: !filter.currency && true,
  })
  //
  //
  // const { data: travelFranchiseByLimits, isLoading: isTravelFranchiseByLimitsLoading } =
  //   api.useGetTravelFranchiseByLimitsQuery(
  //     {
  //       limit: filter.limit as number,
  //       currency: filter.currency as string,
  //     },
  //     {
  //       skip: (!filter.limit || !filter?.currency) && true,
  //     },
  //   )
  //
  //
  // const lowestFranchise = travelFranchiseByLimits && Math.min(...travelFranchiseByLimits?.map((x) => x.value))
  //
  //
  const offerCallBack = useCallback(async () => {
    const GeneratedUniqueId = uuid()
    //

    //
    const localSelectedTravel = filter.singleOrMulti?.split('-')[0] // 'single' or 'multi'
    //
    if (
      filter.productCategory &&
      filter.chooseMethod &&
      localSelectedTravel &&
      filter.region &&
      filter.currency &&
      filter.limit &&
      filter.travelersDate
    ) {
      try {
        //
        dispatch(setUniquedId(GeneratedUniqueId))
        //
        await abroadBestOffer({
          betterOffer: filter.betterOffer || false,
          categorySlug: filter.productCategory,
          whoChoseCompany: filter.chooseMethod,
          userChoseCompanies: filter.chooseMethod === 'user-choice' ? filter.selectedCompanies : [],
          selectedTravel: localSelectedTravel,
          travelMultiDay: localSelectedTravel === 'multi' ? (filter.multiDays?.days as number) : undefined,
          travelDates:
            localSelectedTravel === 'multi'
              ? {
                  start: filter.multiDates?.start as string,
                  end: filter.multiDates?.end as string,
                }
              : {
                  start: filter.singleDates?.start as string,
                  end: filter.singleDates?.end as string,
                },
          travelArea: filter.region,
          selectedPackage: {
            currency: filter.currency,
            limit: filter.limit,
            franchise: undefined, //filter.franchise
          },
          // travelersAge: filter.travelersDate?.map((t) => t.age),
          travelersAge: filter.travelersDate?.map((item) => (item.month === null ? item.age : 0)),
          selectedCoverages: [],
          uniqueId: GeneratedUniqueId,
          travelersBirthdays: filter.travelersDate?.map((t) => ({
            age: t.age,
            birthday: dayjs(t.dateFormat).format('YYYY-MM-DD'),
          })),
        }).unwrap()
        //
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage, { toastId: 'some-id-here' })
          //
        } else {
          toast.error('Some error message')
        }
      }
    }
    //

    //
  }, [
    dispatch,
    filter.betterOffer,
    filter.productCategory,
    filter.chooseMethod,
    filter.selectedCompanies,
    filter.region,
    filter.currency,
    filter.limit,
    // filter.franchise,
    filter.multiDates?.end,
    filter.multiDates?.start,
    filter.multiDays?.days,
    filter.singleOrMulti,
    filter.travelersDate,
    filter.singleDates?.start,
    filter.singleDates?.end,
    abroadBestOffer,
  ])
  //
  //
  useEffect(() => {
    //
    offerCallBack()
    //
    return () => {}
  }, [offerCallBack])
  //
  //
  // Function to find the minimum price and pick one randomly if there are multiple with the same minimum price
  const findMinimumPriceRandomly = (data: AbroadOffer[] | undefined) => {
    if (!data || data.length === 0) {
      return null // Return null when the array is empty or undefined
    }

    // Rest of the function remains the same
    const minPrice = data.reduce((min, product) => {
      return product.calculatedPrices.totalPremium < min ? product.calculatedPrices.totalPremium : min
    }, data[0].calculatedPrices.totalPremium)

    const productsWithMinPrice = data.filter((product) => product.calculatedPrices.totalPremium === minPrice)
    const randomIndex = Math.floor(Math.random() * productsWithMinPrice.length)
    const randomProduct = productsWithMinPrice[randomIndex]

    return randomProduct
  }
  //
  const minimumPriceProduct = findMinimumPriceRandomly(offers || filter.companyOffers)
  //
  // find minimal franchise and price and return random
  const findMinimalFranchiseAndPriceAndReturnRandom = (offers: AbroadOffer[] | undefined) => {
    let bestOffers: any = []

    offers?.forEach((offer) => {
      if (
        !bestOffers.length ||
        offer.calculatedPrices.franchise < bestOffers?.[0]?.calculatedPrices?.franchise ||
        (offer.calculatedPrices.franchise === bestOffers?.[0]?.calculatedPrices?.franchise &&
          offer?.calculatedPrices?.totalPremium < bestOffers?.[0]?.calculatedPrices?.totalPremium)
      ) {
        bestOffers = [offer]
      } else if (
        offer?.calculatedPrices?.franchise === bestOffers?.[0]?.calculatedPrices?.franchise &&
        offer?.calculatedPrices?.totalPremium === bestOffers?.[0]?.calculatedPrices?.totalPremium
      ) {
        bestOffers.push(offer)
      }
    })

    if (bestOffers.length > 1) {
      const randomIndex = Math.floor(Math.random() * bestOffers.length)
      bestOffers = [bestOffers[randomIndex]]
    }

    return bestOffers[0]
  }
  //
  //
  //
  //
  const MainOffer: AbroadOffer | undefined =
    filter.offer && filter.companyOffers?.find((x) => x.companyId === filter.offer?.companyId)
      ? filter.companyOffers?.find((x) => x.companyId === filter.offer?.companyId)
      : filter.betterOffer === true
      ? findMinimalFranchiseAndPriceAndReturnRandom(offers)
      : (minimumPriceProduct as AbroadOffer)
  //
  // auto set main offer in redux store
  useEffect(() => {
    if (MainOffer) {
      dispatch(setOffer(MainOffer))
    }
    //
    return () => {}
  }, [MainOffer, dispatch])
  //
  //
  //
  const setOfferCompanyCallBack = useCallback(async () => {
    if (offers && offers.length >= 1) {
      dispatch(setCompanyOffers(offers))
    }
    //
  }, [offers, dispatch])
  //
  //
  useEffect(() => {
    setOfferCompanyCallBack()
    //
    return () => {}
  }, [setOfferCompanyCallBack])
  //
  //
  //
  // attached Addons Calculate the total price
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator +
              parseInt(item.addon.premium, 10) * (MainOffer?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + item.addon.premium * (MainOffer?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  //
  const offersByLowestPrice = offers
    ?.slice()
    .sort((a, b) => a?.calculatedPrices?.totalPremium - b?.calculatedPrices?.totalPremium)
  //
  //
  // ###############
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })
  // ###############
  //
  // set total price with addon price for next pages
  useEffect(() => {
    //
    const fullPrice =
      offers && offers.length >= 1 && MainOffer?.calculatedPrices?.totalPremium
        ? georgianFormatter.format((MainOffer?.calculatedPrices?.totalPremium as number) + allAddonPrice)
        : 0
    //
    if (MainOffer?.calculatedPrices.totalPremium) {
      dispatch(setOfferTotalPrice(fullPrice as number))
    }
    //
    return () => {}
  }, [allAddonPrice, dispatch, MainOffer?.calculatedPrices?.totalPremium, offers])
  //
  //
  // isTravelFranchiseByLimitsLoading
  const mainLoader = isBestOFferLoading || isTravelCurrenciesLoading
  //
  //
  const parsedWordingFileUrl = MainOffer?.productWording?.includes('translations')
    ? JSON.parse(MainOffer?.productWording)
    : ''
  //
  //
  //
  return mainLoader ? (
    <Loader text={t('chooseBestOffer')} />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('bestOfferForYou')}</title>
        <meta name="description" content={`${t('bestOfferForYou')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={`${t('bestOfferForYou')}`} />
        <AbroadProgressBar stepName={`${t('offer')}`} />

        <Price $pricePosition={scrollPosition}>
          <LeftThreeDot />
          <div>{filter?.offerTotalPrice} ₾</div>
          <RightThreeDot />
        </Price>

        {offers && offers.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '30px',
            }}
            text={t('offerNotFoundChangeSetting')}
          />
        )}

        <Block>
          <OfferTitle
            style={{
              userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
              pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
              opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
            }}
          >
            {t('see')} <b>{MainOffer?.companyName}</b>
            {t('seeCompanyOffer')}
          </OfferTitle>
          <OfferDescription
            style={{
              userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
              pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
              opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
            }}
          >
            {t('youCanChooseOtherCompany')}
          </OfferDescription>
          <CompanySelect
            style={{
              userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
              pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
              opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
            }}
            closeMenuOnSelect={true}
            value={MainOffer?.companyId}
            onChange={(data) => {
              if (data.value) {
                return [
                  dispatch(setOffer(filter.companyOffers?.find((x) => x.companyId === data.value))),
                  dispatch(clearAddon([])),
                  dispatch(clearGroupAddon([])),
                ]
              }
            }}
            isMulti={false}
            maxSelectLenght={3}
            maxSelectText={`${t('companyCmpare')}`}
            placeholder={t('selectCompanies')}
            showInnerPrice={true}
            showOptionCheckmark={true}
            options={offersByLowestPrice?.map((o: AbroadOffer) => ({
              value: o.companyId,
              label: o.companyName,
              imgUrl: o.companyLogo,
              price: o.calculatedPrices.totalPremium,
            }))}
          />

          <br />

          <GetBetterOffer
            style={{
              userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
              pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
              opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
            }}
            defaultValue={filter.betterOffer}
            onChange={(value) => {
              if (value === true) {
                //
                if (filter.chooseMethod === 'frani-choice') {
                  return [
                    // dispatch(setFranchise(lowestFranchise)),
                    dispatch(setOffer(undefined)),
                    dispatch(setBetterOffer(true)),
                  ]
                } else {
                  // dispatch(setFranchise(lowestFranchise)),
                  return [dispatch(setBetterOffer(true))]
                }
                //
              } else {
                //
                if (filter.chooseMethod === 'frani-choice') {
                  return [
                    dispatch(setFranchise(undefined)),
                    dispatch(setOffer(undefined)),
                    dispatch(setBetterOffer(false)),
                  ]
                } else {
                  return [dispatch(setFranchise(undefined)), dispatch(setBetterOffer(false))]
                }
                //
              }
            }}
            title={t('getBetterOffer')}
            description={t('reduceTheFranchise')}
          />

          <HR />

          {MainOffer?.companySlug === 'aldagi' ||
          MainOffer?.companySlug === 'imedi-l' ||
          MainOffer?.companySlug === 'gpih' ? null : (
            <div
              style={{
                userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
                pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
                opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
              }}
            >
              {(MainOffer?.travelAttachedAddons && MainOffer?.travelAttachedAddons?.length >= 1) ||
              (MainOffer?.groupedTravelAttachedAddonInfos &&
                MainOffer?.groupedTravelAttachedAddonInfos?.length >= 1) ? (
                <AddonsBlock
                  style={{
                    opacity: filter.offer?.companyId === MainOffer?.companyId ? 'unset' : '0.7',
                    pointerEvents: filter.offer?.companyId === MainOffer?.companyId ? 'unset' : 'none',
                    userSelect: filter.offer?.companyId === MainOffer?.companyId ? 'unset' : 'none',
                  }}
                >
                  <AddonAccordion>
                    <AddonHead onClick={() => setOpenAddonAccordion(!openAddonAccordion)}>
                      <span>{t('useCoverage')}</span>
                      <RightArrowStyle
                        style={{
                          transform: openAddonAccordion ? 'rotate(-90deg)' : 'rotate(90deg)',
                        }}
                      />
                    </AddonHead>

                    {openAddonAccordion ? (
                      <AddonsContent>
                        {MainOffer && MainOffer.travelAttachedAddons && MainOffer.travelAttachedAddons.length >= 1 ? (
                          <>
                            {MainOffer.travelAttachedAddons &&
                              MainOffer.travelAttachedAddons
                                .filter((x) => x && x.addonId)
                                ?.map((atAddon, atAddonIndex) => {
                                  //
                                  const attachedAddonsInitialCount =
                                    filter.offer?.companyId === MainOffer.companyId &&
                                    filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId)
                                  //
                                  return (
                                    <StandartAddon key={atAddonIndex}>
                                      <AddonLeftDiv>
                                        <AddonImg src={atAddon.addonImage} alt={`addon-img-${atAddonIndex}`} />
                                        <StandartAddonLeftSide>
                                          <span>{atAddon.addonTranslations?.[lang]?.title}</span>
                                          <span>
                                            {t('price')}: {atAddon.premium} ₾
                                            {atAddon.paymentType === 'ONCE' ? (
                                              <> / {t('coverageCost')}</>
                                            ) : (
                                              <> / {t('coverageCostByPerson')}</>
                                            )}
                                          </span>
                                          {filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId) ? (
                                            <span className="offer-addon-description">
                                              {atAddon.translations?.[lang]?.description}
                                            </span>
                                          ) : null}
                                        </StandartAddonLeftSide>
                                      </AddonLeftDiv>

                                      <CountBar
                                        // this ts ignore not important
                                        // @ts-ignore
                                        initialCount={attachedAddonsInitialCount?.count ?? 0}
                                        step={1}
                                        maxCount={filter.travelersDate?.length}
                                        plusOnClick={(value) => {
                                          // create and set new addon
                                          if (
                                            filter.attachedAddons &&
                                            (filter.attachedAddons.length <= 0 ||
                                              filter.attachedAddons.find((x) => x.addon.addonId !== atAddon.addonId)) &&
                                            value === 1
                                          ) {
                                            // create new addon
                                            dispatch(setAddon({ addon: atAddon, count: value }))
                                          }
                                          //
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1 && value > 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                        }}
                                        //
                                        //
                                        minusOnClick={(value) => {
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                          // remove addon by id
                                          if (
                                            filter.attachedAddons &&
                                            filter.attachedAddons.length >= 1 &&
                                            value === 0
                                          ) {
                                            //  remove addon by id
                                            dispatch(removeAddon(atAddon.addonId))
                                          }
                                        }}
                                      />
                                    </StandartAddon>
                                  )
                                })}
                          </>
                        ) : null}

                        {MainOffer &&
                        MainOffer.groupedTravelAttachedAddonInfos &&
                        MainOffer.groupedTravelAttachedAddonInfos.length >= 1 ? (
                          <>
                            {MainOffer.groupedTravelAttachedAddonInfos &&
                              MainOffer.groupedTravelAttachedAddonInfos
                                ?.filter((x) => x && x.id)
                                ?.map((groupAddon, groupAddonIndex) => {
                                  //
                                  const groupAttachedAddonsInitialCount =
                                    filter.offer?.companyId === MainOffer.companyId &&
                                    filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id)
                                  //
                                  return (
                                    <GroupAddon key={groupAddonIndex}>
                                      <StandartAddon>
                                        <AddonLeftDiv>
                                          <CubesIconStyle />
                                          <StandartAddonLeftSide>
                                            <span>{groupAddon.translations?.[lang]?.title}</span>
                                            <span>
                                              {t('price')}: {groupAddon.premium} ₾
                                              {groupAddon.paymentType === 'ONCE' ? (
                                                <> / {t('coverageCost')}</>
                                              ) : (
                                                <> / {t('coverageCostByPerson')}</>
                                              )}
                                            </span>
                                          </StandartAddonLeftSide>
                                        </AddonLeftDiv>
                                        <CountBar
                                          // this ts ignore not important
                                          // @ts-ignore
                                          initialCount={groupAttachedAddonsInitialCount?.count ?? 0}
                                          step={1}
                                          maxCount={filter.travelersDate?.length}
                                          plusOnClick={(value) => {
                                            //
                                            // create and set new addon
                                            if (
                                              filter.groupedAttachedAddons &&
                                              (filter.groupedAttachedAddons.length <= 0 ||
                                                filter.groupedAttachedAddons.find(
                                                  (x) => x.addon.id !== groupAddon.id,
                                                )) &&
                                              value === 1
                                            ) {
                                              // create new addon
                                              dispatch(setGroupAddon({ addon: groupAddon, count: value }))
                                            }
                                            //
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value > 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            //
                                          }}
                                          minusOnClick={(value) => {
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            // remove addon by id
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value === 0
                                            ) {
                                              //  remove addon by id
                                              dispatch(removeGroupAddon(groupAddon.id))
                                            }
                                          }}
                                        />
                                      </StandartAddon>

                                      {groupAddon.addons.map((innerGroupAddon, innerGroupAddonIndex) => (
                                        <GroupAddonDescription key={innerGroupAddonIndex}>
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <DoubleRightIcon />
                                            <span>{innerGroupAddon.addon.translations?.[lang]?.title}</span>
                                          </div>
                                          {filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id) ? (
                                            <span className="offer-addon-description">
                                              {innerGroupAddon.description}
                                            </span>
                                          ) : null}
                                        </GroupAddonDescription>
                                      ))}
                                    </GroupAddon>
                                  )
                                })}
                          </>
                        ) : null}
                      </AddonsContent>
                    ) : null}
                  </AddonAccordion>
                </AddonsBlock>
              ) : null}

              {(MainOffer?.travelAttachedAddons && MainOffer?.travelAttachedAddons?.length >= 1) ||
              (MainOffer?.groupedTravelAttachedAddonInfos &&
                MainOffer?.groupedTravelAttachedAddonInfos?.length >= 1) ? (
                <HR />
              ) : null}
            </div>
          )}

          <AddonsTitle>{t('youCanChange')}</AddonsTitle>

          <DropdownWrapper>
            <Dropdown
              title={`${t('currency')}`}
              value={filter.currency}
              options={travelCurrencies?.map((x) => ({
                value: x.type,
                label: x.type?.toUpperCase(),
              }))}
              placeholder={``}
              onChange={(obj) => {
                if (filter.chooseMethod === 'frani-choice') {
                  return [
                    dispatch(setCurrency(obj.value)),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                    dispatch(setOffer(undefined)),
                  ]
                } else {
                  return [dispatch(setCurrency(obj.value)), dispatch(clearAddon([])), dispatch(clearGroupAddon([]))]
                }
              }}
            />

            <Dropdown
              title={`${t('limit')}`}
              value={filter.limit}
              options={travelLimitsByCurrency?.map((x) => ({
                value: x.value,
                label:
                  x.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ` ${currencySymbol(filter.currency)}`,
              }))}
              placeholder={``}
              onChange={(obj) => {
                if (filter.chooseMethod === 'frani-choice') {
                  return [
                    dispatch(setLimit(Number(obj.value))),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                    dispatch(setOffer(undefined)),
                  ]
                } else {
                  return [
                    dispatch(setLimit(Number(obj.value))),
                    dispatch(clearAddon([])),
                    dispatch(clearGroupAddon([])),
                  ]
                }
              }}
            />
          </DropdownWrapper>

          <HR />

          <OfferTextBox>
            <OffetTextLeftSide>{t('policyType')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {(MainOffer?.calculatedPrices?.travelType === 'single' && lang === 'ge' && 'ერთჯერადი') ||
                (MainOffer?.calculatedPrices?.travelType === 'single' && lang === 'en' && 'single') ||
                (MainOffer?.calculatedPrices?.travelType === 'multi' && lang === 'ge' && 'მრავალჯერადი') ||
                (MainOffer?.calculatedPrices?.travelType === 'multi' && lang === 'en' && 'multi')}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('numberOfDays')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {MainOffer?.calculatedPrices?.insurancesDays} {t('day')}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('startDate')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {dayjs(MainOffer?.calculatedPrices?.startDate).format('D MMMM YYYY')}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('endDate')}</OffetTextLeftSide>
            <OffetTextRightSide>{dayjs(MainOffer?.calculatedPrices?.endDate).format('D MMMM YYYY')}</OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('travelArea')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {filter.region === 'world'
                ? `${t('world')}`
                : filter.region === 'europe'
                ? `${t('europe')}`
                : filter.region === 'schengen'
                ? `${t('schengen')}`
                : null}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('numberOfTravellers')} </OffetTextLeftSide>
            <OffetTextRightSide>
              {filter?.travelersDate?.length} {t('traveler')}
            </OffetTextRightSide>
          </OfferTextBox>

          <HR />

          <OfferTextBox>
            <OffetTextLeftSide>{t('limit')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {filter.limit?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} {currencySymbol(filter.currency)}
            </OffetTextRightSide>
          </OfferTextBox>

          <OfferTextBox>
            <OffetTextLeftSide>{t('franchise')}</OffetTextLeftSide>
            <OffetTextRightSide>
              {MainOffer?.calculatedPrices?.franchise} {currencySymbol(filter.currency)}
            </OffetTextRightSide>
          </OfferTextBox>

          <HR />

          <ATagStyle
            style={{
              userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
              pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
              opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
            }}
            href={
              MainOffer?.productWording?.includes('translations')
                ? parsedWordingFileUrl?.translations?.[lang]?.url
                : undefined
            }
            target="_blank"
          >
            <div>{t('policyTerms')}</div>
            <div>
              <RightLineArrowIcon />
            </div>
          </ATagStyle>
        </Block>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return [
                  navigate('/choose-method'),
                  dispatch(setOffer(undefined)),
                  dispatch(clearAddon([])),
                  dispatch(clearGroupAddon([])),
                ]
              }
              //
              if (filter.chooseMethod === 'user-choice') {
                return [
                  navigate('/travel-offers'),
                  // dispatch(clearAddon([])),
                  // dispatch(clearGroupAddon([])),
                ]
              }
              //
              return [navigate('/choose-method'), dispatch(clearAddon([])), dispatch(clearGroupAddon([]))]
              //
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={offers && offers.length >= 1 && filter.offer !== undefined ? false : true}
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/who-do-you-insure')
              }
              //
              if (filter.chooseMethod === 'user-choice') {
                navigate('/who-do-you-insure')
              }
            }}
          />
        </Buttons>
      </Content>

      <Container
        style={{
          userSelect: offers && offers.length >= 1 ? 'unset' : 'none',
          pointerEvents: offers && offers.length >= 1 ? 'unset' : 'none',
          opacity: offers && offers.length >= 1 ? 'unset' : '0.6',
        }}
      >
        <CoveredWrapper>
          <CoveredTitle>{t('whatIsCovered')}</CoveredTitle>
          <CoveredContent>
            {MainOffer?.travelRisks?.map((item, index) => (
              <CoveredBlock key={index}>
                <CoveredImage src={`${item.icon}`} alt={`${item.riskName}`} />
                <CoveredName>{item?.riskName}</CoveredName>
                {/* @ts-ignore */}
                <CoveredDescription>{item?.pivotData?.riskDescription}</CoveredDescription>

                <CustomLink
                  // @ts-ignore
                  onClick={() => setSelectedCoverageId(item.travelRiskId)}
                  text={t('inDetails')}
                  rightLineIcon={false}
                />

                <VerticalBorder />
              </CoveredBlock>
            ))}
          </CoveredContent>
        </CoveredWrapper>

        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('notCovered')}</span>
            </MessageHead>
            {MainOffer?.notCoveredRisks?.map((item, index) => (
              <MessageText key={index}>
                {/* @ts-ignore */}
                <DoubleRightIcon /> <span>{item.translations?.[lang]?.title}</span>
              </MessageText>
            ))}
          </MessageContent>
        </MessageBox>
      </Container>

      <BaseModal
        // @ts-ignore
        isOpen={MainOffer?.travelRisks?.find((x) => x.travelRiskId === selectedCoverageId) ? true : false}
        onClose={() => setSelectedCoverageId(0)}
      >
        {/* @ts-ignore */}
        {MainOffer?.travelRisks?.find((x) => x.travelRiskId === selectedCoverageId)?.pivotData?.riskDescription}
      </BaseModal>

      {scrollPosition <= 0 && <BackgroundIcon />}
    </Wrapper>
  )
}
//
//
const AddonImg = styled.img`
  width: 40px;
  margin-right: 25px;
  margin-top: 7px;

  ${Responsive.mobile} {
    display: none;
  }
`
const AddonLeftDiv = styled.div`
  display: flex;
  align-items: flex-start;
`
const RightArrowStyle = styled(RightArrow)`
  width: 20px;
  margin-left: auto;
  transform: scale(1.1);
`
const CubesIconStyle = styled(CubesIcon)`
  width: 40px;
  height: 40px;
  margin-right: 25px;

  ${Responsive.mobile} {
    display: none;
  }
`
const AddonHead = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  span {
    font-size: 18px;
    color: ${Colors.primaryBlack};
  }
`
const AddonAccordion = styled.div`
  /*  */
`
const AddonsBlock = styled.div`
  /*  */
`
const GroupAddonDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 63px;

  svg {
    width: 11px;
    margin-right: 9px;
    margin-top: 1px;
  }

  .offer-addon-description {
    font-size: 14px;
    color: ${Colors.primaryBlack};
    margin-top: 10px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    margin-left: 0px;
  }
`
const StandartAddonLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  text-align: left;

  span {
    :not(:first-child) {
      color: ${Colors.nevadaGrey};
    }
  }

  .offer-addon-description {
    margin-right: 20px;
    margin-top: 10px;
  }
`
const StandartAddon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }
`
const GroupAddon = styled.div`
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }

  ${StandartAddon} {
    margin-top: 0px;
    border-bottom: unset;
    padding-bottom: 0px;
  }
`
const AddonsContent = styled.div`
  /*  */
`
// const FailureIconStyle = styled(FailureIcon)`
//   background-color: transparent;
//   width: 200px;
//   height: 180px;
// `
// const FaulureTextP = styled.p`
//   font-size: 20px;
//   color: ${Colors.primaryRed};
//   margin-top: 10px;
//   margin-bottom: 20px;
//   width: 80%;
//   text-align: center;
// `
// const FaulureText = styled.div`
//   font-size: 24px;
//   color: ${Colors.primaryBlack};
//   margin-top: 10px;
//   width: 80%;
//   text-align: center;
// `
// const IconDiv = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   height: inherit;
// `
// const NotFoundOfferBox = styled.div`
//   height: 70vh;
// `
const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /*  */
  &:last-child {
    margin-bottom: 0px;
  }

  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;

    /* message text span */
    span {
      margin-left: 15px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div`
  border-top: 1px solid ${Colors.secondaryGrey};
  padding-top: 30px;
  ${Responsive.tablet} {
    max-width: 700px;
    margin: 0 auto;
  }
`
const CoveredDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  font-weight: normal;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CoveredName = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  font-weight: normal;
  margin-bottom: 20px;
  text-align: center;
`
const VerticalBorder = styled.div`
  background-color: ${Colors.secondaryGrey};
  width: 1px;
  height: 140px;
  position: absolute;
  left: -50px;
  display: none;
  ${Responsive.mobile} {
    display: none;
  }
`
const CoveredImage = styled.img`
  min-height: 40px;
  height: 40px;
  width: 48px;
  margin-bottom: 20px;
`
const CoveredTitle = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 60px;
`
const CoveredBlock = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  a {
    span {
      text-decoration: underline;
    }
  }

  &:first-child {
    ${VerticalBorder} {
      display: none;
    }
  }

  ${Responsive.desktop} {
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  /* responsive */
  ${Responsive.laptop} {
    width: 300px;
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.tablet} {
    width: 300px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.mobile} {
    width: 150px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: none;
      }
    }
  }
`
const CoveredContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 100px 100px;
  ${Responsive.mobile} {
    gap: 20px 20px;
    justify-content: space-around;
  }
`
const CoveredWrapper = styled.div`
  position: relative;
  z-index: 2;
  margin-block: 80px;
  ${Responsive.mobile} {
    margin-bottom: 40px;
    margin-top: 50px;
  }
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 10px;
  color: ${Colors.primaryBlack};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  div {
    line-height: 18px;
    &:last-child {
      margin-left: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        width: 16px;
        height: 10px;
      }
    }
  }
  /*  */
  &:hover {
    color: ${Colors.primaryBlack};
    div {
      svg {
        color: ${Colors.primaryRed};
      }
    }
  }
`
const OfferTextBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
`
const OffetTextLeftSide = styled.span`
  color: ${Colors.primaryGrey};
  font-size: 14px;
`
const OffetTextRightSide = styled.span`
  color: ${Colors.primaryBlack};
  font-size: 14px;
`
const HR = styled.hr`
  margin-block: 24px;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  ${Responsive.laptop} {
    gap: 2rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 2rem 2rem;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1rem 2rem;
  }
`
const OfferDescription = styled.h6`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
`
const OfferTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    font-size: 14px;
  }
`
const AddonsTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const Price = styled.div<{ $pricePosition: number }>`
  position: sticky;
  top: 100px;
  right: 0;
  width: fit-content;
  margin: ${({ $pricePosition }) => ($pricePosition >= 170 ? '0 -300px 0 auto' : '0 auto')};
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  user-select: none;
  pointer-events: none;

  /* text */
  div {
    width: fit-content;
    height: 64px;
    background-color: ${Colors.primaryRed};
    border-radius: 40px;
    color: ${Colors.white};
    font-size: 20px;
    padding-inline: 40px;
    margin-inline: 10px;
    display: grid;
    place-items: center;
    box-shadow: 0 4px 35px 0 rgba(254, 95, 85, 0.32);
  }

  svg {
    height: 64px;
  }

  /* Responsive */
  ${Responsive.laptop} {
    top: 120px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 120 ? '0 -200px 0 auto' : '0 auto')};
    margin-top: 32px;

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      height: 40px;
    }
  }

  ${Responsive.tablet} {
    top: 100px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 160 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 160 ? 'none' : 'unset')};
      height: 40px;
    }
  }

  ${Responsive.mobile} {
    top: 80px;
    margin: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0 0 0 auto' : '0 auto')};
    margin-top: ${({ $pricePosition }) => ($pricePosition >= 100 ? '0px' : '32px')};

    div {
      height: 48px;
      font-size: 16px;
      margin-inline: 0px;
    }

    svg {
      display: ${({ $pricePosition }) => ($pricePosition >= 100 ? 'none' : 'unset')};
      height: 40px;
    }
  }
`
const Block = styled.div`
  max-width: 800px;
  width: calc(100vw - 96px);
  padding: 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  margin-block: 32px 48px;
  border-radius: 8px;

  ${Responsive.mobile} {
    margin-block: 33px;
    padding: 20px;
    width: calc(100vw - 40px);
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`
//
export default TravelOffer
